// src/pages/Cytheseus.js

import React from 'react';
import AtomicGraphic from '../components/AtomicGraphic';

const Cytheseus = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <div style={{ textAlign: 'center' }}>
            <h1>Cytheseus</h1>
          </div>
          <AtomicGraphic />
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default Cytheseus;
